
'use strict';

const $ = require('jquery');
require('../lightslider.js');
require('../lightgallery.js');

$('.product-images').lightSlider({
    gallery: true,
    addClass: 'images',
    item: 1,
    loop: false,
    thumbItem: 10,
    slideMargin: 0,
    enableTouch: true,
    enableDrag: false,
    currentPagerPosition: 'left',
    onSliderLoad: function (el) {
        el.addClass('loaded');
        el.lightGallery({
            selector: '.product-images .lslide',
            actualSize: false,
            autoplayControls: false
        });
        $('.lSSlideWrapper').append('<span id="product-zoom">' + g.lang.vergroot_foto + '</span>');
        
        // INSERT DATA SPECIALS ON EACH CHILD
        const parent = $('.product-images');
        let dataset = parent.data();

        for (let key in dataset) {
            if (dataset.hasOwnProperty(key)) {
                dataset['data-' + key] = dataset[key];
                delete dataset[key];
            }
        }

        $.each(parent.children(), function () {
            $(this).attr(dataset);
        });
    }
});

$('.vergroot-foto').on('click', function () {
    $('.active').trigger('click');
});

$('.list-toggle').on('click', function () {
    $('.product-overview').toggleClass('full');
    $(this).find('i.fa').toggleClass('fa-list fa-th');
});
